import styled from 'styled-components';

const LatestVideosContainer = styled.div``;

export { LatestVideosContainer };
